import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";

import "../styles/kiosk.scss";

export default function KioskLayout() {
  return (
    <>
      <Outlet />
      <ToastContainer />
    </>
  );
}
